export const appTeacherIcon = {
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M2.40625 22.913C2.40625 18.4307 6.03989 14.7971 10.5222 14.7971C15.0045 14.7971 18.6381 18.4307 18.6381 22.913C18.6381 23.3612 18.2748 23.7246 17.8265 23.7246C17.3783 23.7246 17.0149 23.3612 17.0149 22.913C17.0149 19.3272 14.108 16.4202 10.5222 16.4202C6.93635 16.4202 4.02944 19.3272 4.02944 22.913C4.02944 23.3612 3.66608 23.7246 3.21784 23.7246C2.76961 23.7246 2.40625 23.3612 2.40625 22.913Z"
          fill="currentColor"/>
    <path d="M13.8298 9.11589C13.8298 10.9428 12.3488 12.4239 10.5218 12.4239C8.6949 12.4239 7.21387 10.9428 7.21387 9.11589C7.21387 7.28895 8.6949 5.80792 10.5218 5.80792C12.3488 5.80792 13.8298 7.28895 13.8298 9.11589Z"
          stroke="currentColor" stroke-width="1.5"/>
    <path d="M18.7692 14H22V2L2 2V14H3.82692" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" fill="none"/>
    <path d="M12.5 23L18 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="currentColor"/>
</svg>
`,
  name: 'teacher',
};
